"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lsfastapi = exports.Api = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _openapiClientAxios = require("openapi-client-axios");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var debug = false;

var make_client = function make_client(openapi) {
  return function (_ref) {
    var baseurl = _ref.baseurl,
        config = (0, _objectWithoutProperties2["default"])(_ref, ["baseurl"]);
    if (debug) console.log(openapi);
    var api = new _openapiClientAxios.OpenAPIClientAxios({
      definition: openapi,
      axiosConfigDefaults: {
        headers: {// 'Access-Control-Max-Age': '600',
          // 'Access-Control-Allow-Origin': '*',
        }
      }
    });
    api.withServer({
      url: baseurl
    });
    var client = api.initSync();
    return client;
  };
};

var api_name = function api_name(openapi) {
  var name = openapi.info.title.endsWith('-api') ? openapi.info.title.slice(0, -4) : openapi.info.title;
  return name.replace('-', '_');
};

var Api = function Api(openapi) {
  if (debug) console.log(openapi);
  return {
    name: api_name(openapi),
    client: make_client(openapi)
  };
};

exports.Api = Api;

var LSFastAPI = function LSFastAPI() {
  var _this = this;

  (0, _classCallCheck2["default"])(this, LSFastAPI);
  (0, _defineProperty2["default"])(this, "add_api", function (api, options) {
    _this[api.name] = api.client(_objectSpread({}, options));
  });
};

var lsfastapi = new LSFastAPI();
exports.lsfastapi = lsfastapi;
//# sourceMappingURL=index.js.map